import { Flex } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { StyledBox, StyledButton, StyledTypography } from 'styles/common';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { getColorFromKey, goToEngagementTemplateListRoute } from 'constants/helper';

import { Button } from 'uiToolkitV1/Button';

const HeaderActions = ({ actions, primaryText, secondaryText, showBackButton = false, onBackClick = () => {} }) => {
  const history = useHistory();

  const handlePreviousClick = () => {
    goToEngagementTemplateListRoute(history);
    onBackClick();
  };

  return (
    <StyledContainer>
      <Flex alignItems="center">
        {showBackButton && (
          <Button
            mr="8px"
            StartIcon={ArrowBack}
            variant="tertiary"
            onClick={handlePreviousClick}
            data-testid="header-go-back"
          />
        )}
        {primaryText && primaryText}
        {secondaryText && (
          <StyledTypography display="inline" variant="body1" color="textSecondary">
            {secondaryText}
          </StyledTypography>
        )}
      </Flex>
      <StyledBox>
        {actions &&
          actions.map((action, idx) => (
            <CustomStyledButton
              key={idx}
              customColor={action.color}
              borderColor={action.borderColor}
              fontColor={action.fontColor}
              onClick={() => action.onClick && action.onClick()}
              rightGutter={idx === actions.length - 1 ? 0 : 4}
              startIcon={action.icon}
              disabled={action.disabled || false}
            >
              {action.text}
            </CustomStyledButton>
          ))}
      </StyledBox>
    </StyledContainer>
  );
};

export default HeaderActions;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 2rem;
  border: 2px solid ${getColorFromKey('lightGrey')};
  border-radius: 5px;
  max-height: 72px;
`;

const CustomStyledButton = styled(StyledButton)`
  min-width: 20ch;
`;
